import React from 'react';
import FeaturedProperties from '@/components/property/FeaturedProperties';
import { type PropertyCardProps } from '@/components/PropertyCard';

interface RecommendedPropertiesProps {
  properties: PropertyCardProps[];
  title?: string;
  onViewAll?: () => void;
  className?: string;
}

const RecommendedProperties: React.FC<RecommendedPropertiesProps> = ({
  properties,
  title = 'Sugeridos para você',
  onViewAll,
  className
}) => {
  return (
    <FeaturedProperties
      title={title}
      properties={properties}
      showFilters={false}
      showViewAll={true}
      onViewAll={onViewAll}
      variant="carousel"
      className={className}
    />
  );
};

export { RecommendedProperties, type RecommendedPropertiesProps };
export default RecommendedProperties;


